/*
 * Copyright (c) 2019. Botanická zahrada Přírodovědecké fakulty Univerzity Karlovy, Juraj Šimon
 */
const urlParams = new URLSearchParams(window.location.search);

const DEFAULT_LOCALE = "en";

function autoDetect() {
  return (
    urlParams.get("locale") || localStorage.getItem("locale") || DEFAULT_LOCALE
  );
}

export { autoDetect };
